import React from 'react';
const problems = ['Pasas horas buscando ejercicios en internet sin encontrar lo que necesitas', 'Tus sesiones no tienen una estructura clara ni progresión lógica', 'No sabes cómo planificar la temporada completa de forma organizada', 'Repites siempre los mismos ejercicios porque no tienes variedad', 'Llegas al entrenamiento sin un plan claro y terminas improvisando', 'Tus jugadores no progresan al ritmo que deberían porque falta metodología'];
export function ProblemSection() {
  return <section className="w-full bg-white py-16 px-4" data-id="element-159">
      <div className="max-w-3xl mx-auto text-center" data-id="element-160">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-[#0A0A0A] mb-10 tracking-tight leading-tight" data-id="element-161">
          Si entrenas fútbol juvenil, probablemente estás viviendo al menos uno
          de estos problemas:
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-left mb-12" data-id="element-162">
          {problems.map((problem, i) => <div key={i} className="flex items-start gap-3 bg-[#FAFAFA] border border-[#E5E5EA] rounded-2xl p-4 shadow-sm" data-id="element-163">
              <span className="text-red-500 text-xl flex-shrink-0" data-id="element-164">❌</span>
              <p className="text-[#0A0A0A] text-sm sm:text-base font-semibold leading-snug" data-id="element-165">
                {problem}
              </p>
            </div>)}
        </div>

        <p className="text-[#00A650] text-2xl sm:text-4xl font-black mb-8 tracking-tight" data-id="element-166">
          ¿Tus entrenamientos todavía los sigues improvisando?
        </p>

        <div className="h-px bg-gradient-to-r from-transparent via-[#E5E5EA] to-transparent w-full" data-id="element-167" />
      </div>
    </section>;
}